import React, { useEffect, useState } from 'react';
import { apsisEncrypt } from '../../helpers/apsisEncryption';
import fetchWrapper from '../../helpers/fetchWrapper';
import { AutoComplete } from 'antd';

export const SuggestionSelect = ({
	value,
	getEvent,
	slug,
	placeholder,
	disabledOptions = [],
	onChange,
	extra,
	name,
	...rest
}) => {
	const [selectedValue, setSelectedValue] = useState(null);
	const [options, setOptions] = useState([]);
	const [filteredOptions, setFilteredOptions] = useState([]);
	const convertOptions = (opts) => {
		const oldValues = [...opts];
		return oldValues.map((item) => ({ ...item, disabled: disabledOptions.includes(item.value) }));
	};
	const changeHandler = (value) => {
		const selectedItem = options ? options.find((item) => item.value == value) : [];
		if (getEvent) {
			const target = {
				name,
				value,
				selectedItem,
			};
			getEvent({ target });
		}
		if (onChange) {
			onChange(value);
		}
		setSelectedValue(selectedItem?.label ?? value);
	};
	// fetch data
	const fetchData = async () => {
		const response = await fetchWrapper.post('dropdown/dropdowndata', {
			dropdown_slug: slug,
			external_data: extra ? apsisEncrypt(extra) : '',
		});

		if (!response.error && response.data) {
			setOptions(convertOptions(response.data));
			setFilteredOptions(convertOptions(response.data));
			// if (response.data.length === 1) {
			// 	changeHandler(response.data[0].value);
			// }
		}
	};

	useEffect(() => {
		if (slug && slug != '') {
			fetchData();
		}
	}, [extra, slug]);

	useEffect(() => {
		value &&
			setTimeout(() => {
				setSelectedValue(value);
			}, 100);
	}, [value]);

	return (
		<AutoComplete
			options={filteredOptions}
			value={selectedValue}
			onChange={changeHandler}
			onSearch={(text) =>
				setFilteredOptions(options.filter((item) => item.label.toLowerCase().includes(text.toLowerCase())))
			}
			placeholder="Write Here"
			{...rest}
		/>
	);
};

export default SuggestionSelect;
